import { Injectable, NgModule } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { map, catchError } from "rxjs/operators";
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse
} from "@angular/common/http";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { Router } from "@angular/router";
import Swal from "sweetalert2";
import { LoadingBarService } from "@ngx-loading-bar/core";

@Injectable()
export class HttpsRequestInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private loadingBarService: LoadingBarService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let dupReq;

    if (
      localStorage.hasOwnProperty("accessToken") &&
      !req.url.includes("/login")
    ) {
      dupReq = req.clone({
        headers: req.headers
          .set("Content-Type", "application/json")
          .set("application_token", "fs")
          .set("Authorization", "Bearer " + localStorage.getItem("accessToken"))
      });
    } else {
      dupReq = req.clone({
        headers: req.headers.set("Content-Type", "application/json")
      });
    }

    return next
      .handle(dupReq)
      .pipe(
        map((event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            if (event.status === 203) {
              this.loadingBarService.stop();

              Swal({
                type: "warning",
                title: "Erro 203",
                text: event.body,
                confirmButtonText: "Ok, obrigado.",
                confirmButtonClass: "sweet-button",
                buttonsStyling: false
              });
            }

            if (event.status === 204) {
              this.loadingBarService.stop();

              Swal({
                type: "warning",
                title: "Erro 204",
                text: "Não há resposta da api, contate o suporte.",
                confirmButtonText: "Ok, obrigado.",
                confirmButtonClass: "sweet-button",
                buttonsStyling: false
              });
            }
          }

          return event;
        })
      )
      .pipe(
        catchError((error: HttpErrorResponse) => {
          if (error instanceof HttpErrorResponse) {
            if (error.status === 0) {
              this.loadingBarService.stop();

              Swal({
                type: "error",
                title: "Erro de Conexão",
                text:
                  "Houve um erro ao conectar no servidor, verifique se você está conectado na rede interna.",
                confirmButtonText: "Ok, obrigado.",
                confirmButtonClass: "sweet-button",
                buttonsStyling: false
              });
            }

            if (error.status === 401) {
              this.loadingBarService.stop();

              localStorage.clear();

              this.router.navigate(["/login"]);

              Swal({
                type: "warning",
                title: "Erro 401",
                text: "Usuário/Senha inválidos, efetue o login novamente.",
                confirmButtonText: "Ok, obrigado.",
                confirmButtonClass: "sweet-button",
                buttonsStyling: false
              });
            }

            if (error.status === 409) {
              this.loadingBarService.stop();

              Swal({
                type: "warning",
                title: "Erro 409",
                text: "Houve um erro interno no servidor, contate o suporte.",
                confirmButtonText: "Ver erro!",
                confirmButtonClass: "sweet-button",
                showCancelButton: true,
                buttonsStyling: false,
                cancelButtonClass: "sweet-button-cancel",
                cancelButtonText: "Fechar"
              }).then(result => {
                if (result.value) {
                  Swal({
                    title: "Mensagem!",
                    text: `${error.error}`,
                    type: "error",
                    confirmButtonClass: "sweet-button",
                    confirmButtonText: "Fechar",
                    buttonsStyling: false
                  });
                }
              });
            }

            if (error.status === 500) {
              this.loadingBarService.stop();

              Swal({
                type: "error",
                title: "Erro 500",
                text: "Houve um erro interno no servidor, contate o suporte.",
                confirmButtonText: "Ok, obrigado.",
                confirmButtonClass: "sweet-button",
                buttonsStyling: false
              });
            }
          }

          return throwError(error);
        })
      );
  }
}

@NgModule({
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpsRequestInterceptor,
      multi: true
    }
  ]
})
export class Interceptor {}
